const ImpressumPage = () => {
  return (
    <div data-testid="impressum-page">
      {/* Hero Section */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold uppercase tracking-tight text-slate-900">
            Impressum
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="legal-content">
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              <strong>Pure Epox</strong><br />
              Inhaber: Mehmet Semih Aytekin<br />
              Einzelunternehmen
            </p>

            <p>
              Steubenstraße 23<br />
              35576 Wetzlar<br />
              Deutschland
            </p>

            <h2>Kontakt</h2>
            <p>
              Telefon: <a href="tel:+4917672636169">+49 176 72636169</a><br />
              E-Mail: <a href="mailto:pureepox@gmail.com">pureepox@gmail.com</a>
            </p>

            <h2>Steuernummer</h2>
            <p>039 802 60620</p>

            <h2>Umsatzsteuer-Identifikationsnummer</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br />
              DE458589866
            </p>

            <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>
              Mehmet Semih Aytekin<br />
              Steubenstraße 23<br />
              35576 Wetzlar<br />
              Deutschland
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;
